import { defineMessages } from 'react-intl';

/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	shortcutActionContextualLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	shortcutActionOpenMenuLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	shortcutActionContextualLabel: {
		id: 'global-shortcuts.shortcut-action.shortcutActionContextualLabel',
		description:
			'Accessible label for the shortcut actions button. appName is the localized name of the app, for example Teams.',
		defaultMessage: 'More actions for {appName}',
	},
	shortcutActionOpenMenuLabel: {
		id: 'navigation.global-shortcuts.shortcut-action.open-menu-label',
		description: 'Label for shortcut action items button',
		defaultMessage: 'open menu',
	},
});
